module.exports = __webpack_public_path__ + "static/img/CgoRC2ORkPGAJ6JlAAJJ-lfx5To897.c0d02bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2ORkPGAJ6JlAAJJ-lfx5To897.jpg
// module id = QfIx
// module chunks = 73